<p-table #dt3 [value]="questionGroups" [paginator]="true" [rows]="15" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="tableShowMore"
    [globalFilterFields]="['name','createdByName','updatedDate','statusId']">
    <ng-template pTemplate="caption">
        <div class="table-header p-d-flex p-jc-between">
            <div>
                <p-toggleButton class="p-mb-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                    [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive" (onChange)="getQuestionGroups()">
                </p-toggleButton>
            </div>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt3.filterGlobal($event.target.value, 'contains')"
                    placeholder="Search..." />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Updated Date</th>
            <th>Is Active</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-groupDetails let-i="rowIndex">
        <tr>
            <td>{{groupDetails.name}}</td>
            <td>{{groupDetails.createdByName}}</td>
            <td>{{groupDetails.createdDate | localDate: 'MM/DD/YYYY'}}</td>
            <td>{{groupDetails.updatedDate | localDate: 'MM/DD/YYYY'}}</td>
            <td>{{groupDetails.statusId==1?'Yes':'No'}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="editQuestionGroup(groupDetails)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="deleteQuestionGroup(groupDetails)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7">{{ emptyMessage }}</td>
        </tr>
    </ng-template>
</p-table>




<p-dialog [header]="addeEditDialogHeader" [(visible)]="displayQuestionGroupAddEdit" (onHide)="cancelAddEdit()" [modal]="true" [closable]="true" [style]="{width: '50vw'}">
    <div class="header" style="margin-top:1px">
        <h5>Group Information
            <p-inputSwitch class="header-switch" [(ngModel)]="selectedQuestionGroup.isActive"></p-inputSwitch>
        </h5>
    </div>
    <form #questionForm="ngForm">
        <div style="width:100%" class="p-grid">
            <div class="p-col-12">
                <label for="name" class="p-mt-2">Question Group Name <span style="color: red;">*</span></label>
                <input type="text" pInputText [(ngModel)]="selectedQuestionGroup.name" name="name" required>
            </div>
        </div>
        <div class="grid">
            <div class="p-col-12">
                <p-table [value]="questionnaireQuestions" #dt dataKey="id" [reorderableColumns]="true"
                    (onRowReorder)="onRowReorder($event)" [globalFilterFields]="['name', 'isValid']">
                    <ng-template pTemplate="caption">
                        <div class="p-text-right">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Search Question" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:3rem"></th>
                            <th pReorderableColumn>Questions</th>
                            <th style="width: 200px;" class="p-text-center" pReorderableColumn>Display</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-questionDetails let-index="rowIndex">
                        <tr [pReorderableRow]="index">
                            <td>
                                <span class="pi pi-bars" pReorderableRowHandle></span>
                            </td>
                            <td>{{questionDetails.name}}</td>
                            <td class="p-text-center">
                                <p-checkbox [(ngModel)]="questionDetails.isValid" [binary]="true" [ngModelOptions]="{standalone: true}" (onChange)="onCheckboxChange(questionDetails)"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">No questions found.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelAddEdit()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!selectedQuestionGroup.name || !getSelectedQuestions || formSubmitted" (click)="saveQuestionGroup()" label="Save"></button>
    </ng-template>
</p-dialog>
